import { render, staticRenderFns } from "./ScrollTab.vue?vue&type=template&id=7bc961ea&scoped=true&"
import script from "./ScrollTab.vue?vue&type=script&lang=ts&"
export * from "./ScrollTab.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollTab.vue?vue&type=style&index=0&id=7bc961ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc961ea",
  null
  
)

export default component.exports